const GlobalReducer = (state, action) => {
  switch (action.type) {
    case "SET_ACCESS_TOKEN":
      return {
        ...state,
        accessToken: action.payload,
      };
    case 'SET_SONG_DETAIL_PAGE':
      return {
        ...state,
        songDetailPage: action.payload
      }
    default:
      return state;
  }
};

export default GlobalReducer;
